import Table from './Tables';
import { SortableTableStore } from './store';
export default Object.assign(Table, { SortableTableStore });
